import React from "react"
import StepsUserFormBase from "./StepsUserFormBase"
import { connect } from "react-redux"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps} from "../../Redux/Selectors"
import { Form } from "antd"
import { withBreakpoints } from "react-breakpoints"
import { withRouter } from 'react-router-dom'
import '../../Styles/UserPanel/Invoice.css'
import PaymentForm from "../../Components/Payments/PaymentForm"

class InitialPlan extends React.Component {


    render() {


        return (
            <StepsUserFormBase
                title= ' '
            >
                <PaymentForm
                stepsUser={true}
                initialStep={parseInt(this.props.match.params.id)}/>
            </StepsUserFormBase>
        );
    }
}

const PlanInitial = Form.create({ nombre: 'plans' })(withBreakpoints(InitialPlan));

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PlanInitial));
